import { BoundsSnapGeometry, Rectangle2d, HTMLContainer, BaseBoxShapeUtil, TLParentId } from "@tldraw/tldraw";

export interface CustomBoxShapeType {
  type: string;
  x: number;
  y: number;
  w: number;
  h: number;
  rotation: number;
  isLocked: boolean;
  opacity: number;
  parentId: TLParentId;
  id: string;
  fill: string;
}
// @ts-ignore
export class BoxForTemplateUtilFront extends BaseBoxShapeUtil<CustomBoxShapeType> {
  static type = "custom-box" as const;

  getDefaultProps(): CustomBoxShapeType {
    return {
      type: "format-A6",
      x: 0,
      y: 0,
      w: 250,
      h: 400,
      rotation: 0,
      isLocked: true,
      opacity: 1,
      parentId: "page" as TLParentId,
      id: "default-id",
      fill: "white",
    };
  }

  getBoundsSnapGeometry(shape: CustomBoxShapeType): BoundsSnapGeometry {
    return new Rectangle2d({
      width: shape.w,
      height: shape.h,
      isFilled: true,
      x: 0,
      y: 0,
    });
  }

  component(shape: CustomBoxShapeType) {
    const id = shape.id.replace(/^shape:/, "");

    return (
      <HTMLContainer
        id={id}
        style={{
          // @ts-ignore
          backgroundColor: shape.props.fill,
        }}
        className="relative flex items-center justify-center"
      ></HTMLContainer>
    );
  }

  indicator(shape: CustomBoxShapeType) {
    return this.component(shape);
  }
}
